import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { Angulartics2Module } from 'angulartics2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import {
  FormValidationModule,
  ChatCounterModule,
  ReplaceSmartPunctuationModule,
  UtilsModule,
  SmsWarningModule,
  DropdownFilterModule,
  SearchBarModule,
  SwitcherModule,
} from '@tablesready/common-ui';
import { NotificationsComponent } from './notifications.component';
import { NotificationsRoutingModule } from './notifications.routing.module';
import { RepliesComponent } from './replies';
import { AddEditReplyComponent } from './add-edit-reply';
import { LocationNameColumnModule, SmsUsageModule } from '../../../components';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { AuthModule } from '@tablesready/frontend-auth';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';
import { FrontendModalModule } from '@tablesready/frontend-modal';

@NgModule({
  declarations: [NotificationsComponent, RepliesComponent, AddEditReplyComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AuthModule,
    AlertsModule,
    FormValidationModule,
    ChatCounterModule,
    ReplaceSmartPunctuationModule,
    Angulartics2Module,
    UtilsModule,
    NgbModule,
    SmsWarningModule,
    NotificationsRoutingModule,
    DropdownFilterModule,
    FrontendIconsModule,
    LocationNameColumnModule,
    SearchBarModule,
    SmsUsageModule,
    SwitcherModule,
    FrontendPullRefreshModule,
    FrontendModalModule,
  ],
})
export class NotificationsModule {}
